
export default {
  name: 'DesctopItemMainMenu',

  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    children: function () {
      return (this.item?.children || []).filter((t) => !t.isHidden);
    },

    isChildren: function () {
      return (this.children || []).length > 0;
    },
  },

  methods: {
    pathTo(path) {
      if (path.startsWith('https')) {
        return path;
      }
      return `/${path}`;
    },
    isSelected(path) {
      const activePath = this.$route?.path || '';

      return Boolean(`/${path}` === activePath);
    },

    clickChildren(path) {
      if (path && path.startsWith('https')) {
        window.location.href = path;
      } else {
        this.$router.push(`/${path}`);
      }

      this.$refs.refItem.classList.remove('hover');
      setTimeout(() => {
        this.$refs.refItem.classList.add('hover');
      }, 100);
    },

    clickItem: function () {
      if (!this.isChildren) {
        this.$router.push(`/${this.item?.path}`);
      }
    },
  },
};
